import { Disclosure } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
import { FAQData, FAQQuestion } from '@components/BinStore/types'

function BinStoreFAQItem({ question, answer }: FAQQuestion) {
  return (
    <Disclosure
      as="div"
      key={question}
      className="py-4 px-2 border-x-0 border-t-[1px] border-bidfta-blue-backdrop-light"
    >
      {({ open }) => (
        <>
          <dt>
            <Disclosure.Button className="flex w-full items-start justify-between text-left text-white">
              <span className="text-black font-bold leading-7">{question}</span>
              <span className="ml-6 flex h-7 items-center">
                {open ? (
                  <MinusSmallIcon
                    className="h-6 w-6 text-black"
                    aria-hidden="true"
                  />
                ) : (
                  <PlusSmallIcon
                    className="h-6 w-6 text-black"
                    aria-hidden="true"
                  />
                )}
              </span>
            </Disclosure.Button>
          </dt>
          <Disclosure.Panel as="dd" className="py-4">
            <p className="text-black font-light text-left">{answer}</p>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

function BinStoreFAQs({ data }: { data: FAQData[] }) {
  return (
    <div className="border-b-[1px] border-bidfta-blue-backdrop-light">
      {data.map((item: any, index: number) => (
        <BinStoreFAQItem {...item} key={`faq-qa-${index}`} />
      ))}
    </div>
  )
}

export default BinStoreFAQs
